export default "__VITE_ASSET__DPh1u9N2__"